import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import authReducer from './authSlice';

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  // Add other reducers if any
});

// Configure persist options
const persistConfig = {
  key: 'root',
  storage,
  // Add blacklist or whitelist if needed
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
export const store = configureStore({
  reducer: persistedReducer,
});

// Create the persisted store
export const persistedStore = persistStore(store);
